import { createContext, useContext } from 'react';
import { IUserContext } from '../models/User';

const AuthContext = createContext<IUserContext | null>(null);

function useAuth() {
    return useContext(AuthContext);
}

export { AuthContext, useAuth }